// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__B-IK7","loadingAnimation":"CircularProgress_loadingAnimation__ITqmj"};